import React, {useEffect, useState, useRef} from 'react';
import {useStyles} from "./styles/MemberTableStyle";
import {
    Box,
    Button,
    Typography,
    TablePagination,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Tabs,
    Tab,
    TextField,
    IconButton,
    Popover, FormControl, Select, MenuItem
} from "@material-ui/core";
import PropTypes from 'prop-types';
import clsx from "clsx";
import AddMember from "./AddMember";
import MemberDetail from "./ModifyMember";
import UploadDetail from "./UploadDetail";
import { ReactComponent as TableSortIcon } from '../../../common/images/TableSortIcon.svg';
import { ReactComponent as TextFieldDownIcon } from '../../../common/images/TextFieldDownIcon.svg';
import { ReactComponent as AlignLeftIcon } from '../../../common/images/AlignLeftIcon.svg';
import { ReactComponent as ArrowDownIcon } from '../../../common/images/ArrowDownIcon.svg';
import { ReactComponent as DownloadFile } from '../../../common/images/DownloadFile.svg';
import { ReactComponent as UploadFile } from '../../../common/images/UploadFile.svg';
import { ReactComponent as AddaccountIcon } from '../../../common/images/AddaccountIcon.svg';
import { ReactComponent as TooltipClose } from '../../../common/images/TooltipClose.svg';
import { ReactComponent as TooltipTipIcon } from '../../../common/images/TooltipTipIcon.svg';
import {inject, observer} from "mobx-react";
import {USER_TYPE} from "../../../stores/UserStore";
import {DATE_UTIL} from "../../../common/util/date/date.util";
import {LocaleGroupType, LocaleType} from "../../../common/enums/MemberEnum";
import {injectIntl} from "react-intl";
import * as XLSX from "xlsx";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function MemberTable(props) {
    const classes = useStyles();
    const {intl} = props;
    const {userStore, authStore} = props;
    const userType = props.authStore.getUserType();

    useEffect(() => {
        switch (userType) {
            case USER_TYPE.Admin:
                userStore.setSelectedTab('LocaleAdmin');
                userStore.getUsers();
                break;
            case USER_TYPE.LocaleAdmin:
                userStore.setSelectedTab('GroupAdmin');
                userStore.getUsers(authStore.loginUser.id);
                break;
            case USER_TYPE.GroupAdmin:
                userStore.setSelectedTab('Normal');
                userStore.getUsers(authStore.loginUser.id);
                handleOpenPopover();
                break;
            default:
                break;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        const selectedTab = tabList.find(tab => tab.id === newValue);
        if (userStore.selectedTab !== selectedTab.type) {
            userStore.setSelectedTab(selectedTab.type);
            userStore.getUsers(authStore.loginUser.id);

            if (selectedTab.type === 'Normal') {
                handleOpenPopover();
            }
            setValue(newValue);
        }
    };

    const handleChangePage = (event, newPage) => {
        userStore.setPage(authStore.loginUser.id, newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        userStore.setRowsPerPage(authStore.loginUser.id, parseInt(event.target.value, 10));
        userStore.setPage(authStore.loginUser.id, 0);
    };

    const anchorElRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(0);

    const handleOpenPopover = () => {
        setAnchorEl(anchorElRef.current);
        userStore.setPopoverState(true);
    }

    const handleClosePopover = () => {
        setAnchorEl(null);
        userStore.setPopoverState(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const tabList = [
        {id: 0, label: intl.formatMessage({id: "Normal"}), type: 'Normal'}
    ];

    if (authStore.loginUser) {
        if (userType === USER_TYPE.Admin || userType === USER_TYPE.LocaleAdmin) {
            tabList[0].id = 1;
            tabList.unshift({id: 0, label: intl.formatMessage({id: "GroupAdmin"}), type: 'GroupAdmin'});
        }
        if (userType === USER_TYPE.Admin) {
            tabList[0].id = 1;
            tabList[1].id = 2;
            tabList.unshift({id: 0, label: intl.formatMessage({id: "LocaleAdmin"}), type: 'LocaleAdmin'});
        }
    }

    const searchTypeList = [
        {value: 'all', label: intl.formatMessage({id: "All"})},
        {value: 'id', label: 'ID'},
        {value: 'localeCode', label: intl.formatMessage({id: "Locale"})},
    ]
    switch (userStore.selectedTab) {
        case 'LocaleAdmin':
            searchTypeList.push({value: 'email', label: intl.formatMessage({id: "email"})});
            searchTypeList.push({value: 'state', label: intl.formatMessage({id: "member_state"})});
            break;
        case 'GroupAdmin':
            searchTypeList.push({value: 'groupType', label: intl.formatMessage({id: "group_type"})});
            searchTypeList.push({value: 'groupName', label: intl.formatMessage({id: "group_name"})});
            searchTypeList.push({value: 'email', label: intl.formatMessage({id: "email"})});
            searchTypeList.push({value: 'localeAdminUserId', label: `${intl.formatMessage({id: "LocaleAdmin"})} ID`});
            searchTypeList.push({value: 'state', label: intl.formatMessage({id: "member_state"})});
            break;
        default:
            searchTypeList.push({value: 'groupType', label: intl.formatMessage({id: "group_type"})});
            searchTypeList.push({value: 'groupName', label: intl.formatMessage({id: "group_name"})});
            searchTypeList.push({value: 'groupAdminUserId', label: `${intl.formatMessage({id: "GroupAdmin"})} ID`});
            searchTypeList.push({value: 'state', label: intl.formatMessage({id: "member_state"})});
            break;
    }

    const subSearchTypeList = [{value: 'all', label: intl.formatMessage({id: "All"})}]
    switch (userStore.tempSearchType) {
        case 'state':
            subSearchTypeList.push({value: 'Enable', label: intl.formatMessage({id: "Enable"})});
            subSearchTypeList.push({value: 'Disable', label: intl.formatMessage({id: "Disable"})});
            subSearchTypeList.push({value: 'Lock', label: intl.formatMessage({id: "Lock"})});
            subSearchTypeList.push({value: 'Withdraw', label: intl.formatMessage({id: "Withdraw"})});
            break;
        case 'groupType':
            for (const type in LocaleGroupType) {
                subSearchTypeList.push({value: type, label: intl.formatMessage({id: type})});
            }
            break;
        default:
            for (const local in LocaleType) {
                subSearchTypeList.push({value: local, label: intl.formatMessage({id: local})});
            }
            break;
    }

    const getPlaceholder = () => {
        switch (userStore.tempSearchType) {
            case 'id':
                return intl.formatMessage({id: "search_account"});
            case 'email':
                return intl.formatMessage({id: "search_email"});
            case 'localeAdminUserId':
                return intl.formatMessage({id: "search_locale_admin"});
            case 'groupName':
                return intl.formatMessage({id: "search_group"});
            case 'groupAdminUserId':
                return intl.formatMessage({id: "search_group_admin"});
            default:
                return '';
        }
    }

    const handleChangeSearchType = (e) => {
        userStore.setTempSearchType(e.target.value)
    }

    const handleChangeSearchText = (e) => {
        userStore.setTempSearchText(e.target.value);
    }

    const handleClickCreatedDateSort = () => {
        if (userStore.sortColumn === 'created_datetime') {
            userStore.setIsSortAscending(!userStore.isSortAscending);
        } else {
            userStore.setSortColumn('created_datetime');
            userStore.setIsSortAscending(false);
        }
        userStore.getUsers(authStore.loginUser.id);
    };

    const handleClickLastLoginDatetimeSort = () => {
        if (userStore.sortColumn === 'last_login_datetime') {
            userStore.setIsSortAscending(!userStore.isSortAscending);
        } else {
            userStore.setSortColumn('last_login_datetime');
            userStore.setIsSortAscending(false);
        }
        userStore.getUsers(authStore.loginUser.id);
    };

    const handleClickSearch = () => {
        userStore.setSearchValue();
        userStore.getUsers(authStore.loginUser.id, true);
    }

    const handleClickGroupCount = (localeAdminUserId) => {
        userStore.setSelectedTab('GroupAdmin');
        userStore.setSearchType('localeAdminUserId');
        userStore.setSearchText(localeAdminUserId);
        setValue(tabList.findIndex(tab => tab.type === 'GroupAdmin'));
        handleClickSearch();
    }

    const handleClickUserCount = (groupAdminUserId) => {
        userStore.setSelectedTab('Normal');
        userStore.setSearchType('groupAdminUserId');
        userStore.setSearchText(groupAdminUserId);
        setValue(tabList.findIndex(tab => tab.type === 'Normal'));
        handleClickSearch();
        handleOpenPopover();
    }

    const handelClickManage = (userId) => {
        userStore.getUser(userId, (localeCode, localeAdminUserId) => {
            userStore.getLocaleAdminUserIdList(localeCode, () => {
                userStore.getLocaleGroupList(localeAdminUserId, () => userStore.setModifyUserDialogOpen(true));
            })
        });
    }

    const handleClickAddUser = () => {
        switch (userType) {
            case USER_TYPE.Admin:
                userStore.setAddUserDialogType('LocaleAdmin');
                break;
            case USER_TYPE.LocaleAdmin:
                userStore.getLocaleGroupList(authStore.loginUser.id);
                userStore.setAddUserDialogType('GroupAdmin');
                break;
            default:
                userStore.getLocaleGroup(authStore.loginUser.id, () => userStore.getGroupConfigs(userStore.newGroupUser.localeGroupId, () => {
                    const newGroupUser = Object.assign({}, userStore.newGroupUser);

                    const defaultEmailConfig = userStore.localeGroupConfigList.find(config => config.configKey === 'DefaultEmail');
                    if (defaultEmailConfig) {
                        const defaultEmail = defaultEmailConfig.value;
                        userStore.setNewGroupUserSecondId(defaultEmail);
                    }

                    const defaultPasswordConfig = userStore.localeGroupConfigList.find(config => config.configKey === 'DefaultPassword');
                    if (defaultPasswordConfig) {
                        newGroupUser.password = defaultPasswordConfig.value;
                    }

                    userStore.setNewGroupUser(newGroupUser);
                }));

                userStore.setAddUserDialogType('Normal');
                break;
        }
        userStore.setAddUserDialogOpen(true);
    }

    const handleClickDownLoadForm = () => {
        userStore.downloadUserUploadForm();
    }

    const handleClickUpload = () => {
        if (userType !== USER_TYPE.GroupAdmin) {
            userStore.initUploadDetail(userType, authStore.loginUser.id);
        } else {
            userStore.openFileExplorer();
        }
    }

    const uploadFile = (e) => {
        userStore.setUploadUserList([]);
        userStore.setUploadDetailDialogOpen(false);
        const file = e.target.files[0];
        if (file) {
            parsingExcelToJson(file, () => userStore.uploadFile(intl, authStore.loginUser.id));
        }
        e.target.value = '';
    }

    const parsingExcelToJson = (file, callback) => {
        let reader = new FileReader();
        reader.onload = async (e) => {
            let data = e.target.result;
            let workbook = XLSX.read(data, {type: 'binary'});
            await workbook.SheetNames.forEach((item, index, array) => {
                if (item === "Data") {
                    const ref = workbook.Sheets[item]["!ref"];
                    if (ref) {
                        const ws = workbook.Sheets[item];
                        const startRow = 4;
                        const uploadUserList = [];

                        for (let rowIndex = startRow; ; rowIndex++) {
                            const cellB = ws['B' + rowIndex];
                            const cellC = ws['C' + rowIndex];
                            const cellD = ws['D' + rowIndex];

                            if (!cellB || !cellC) {
                                break;
                            }

                            const id = cellB.v;
                            const name = cellC.v;
                            const password = cellD ? cellD.v : null;
                            let localeGroupId = null;

                            if (userType !== USER_TYPE.GroupAdmin) {
                                localeGroupId = userStore.uploadDetail.localeGroupId;
                            } else {
                                localeGroupId = authStore.loginUser.localeGroupId;
                            }

                            uploadUserList.push({id: id, name: name, password: password, localeGroupId: localeGroupId, isLeader:false, email: id});
                        }
                        userStore.setUploadUserList(uploadUserList);
                    }
                }
            });
            callback && callback();
        };
        reader.readAsBinaryString(file);
    }

    return (
        <Box className={classes.root}>
            <Box display={"flex"} justifyContent={"space-between"}>

            </Box>

            <Box>
                <Box position="static" className={classes.tabBox}>
                    <Tabs value={value} onChange={handleChange}>
                        {tabList.map((tab,index) => (
                            <Tab id={String(tab.id)} key={index} label={tab.label} {...a11yProps(tab.id)} disableRipple/>
                        ))}
                    </Tabs>
                    <Box className={classes.setBtn} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                        <div ref={anchorElRef}>
                            {userStore.selectedTab === 'Normal' &&
                                <>
                                    <IconButton className={classes.iconButton} disableRipple onClick={handleClickDownLoadForm}>
                                        <DownloadFile />
                                    </IconButton>
                                    <Popover
                                        id={id}
                                        open={userStore.popoverState === null ? false : userStore.popoverState}
                                        anchorEl={anchorEl}
                                        onClose={handleClosePopover}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center',
                                        }}
                                        className={classes.popoverTooltip}
                                    >
                                        <Box className={classes.tooltipTop}>
                                            <TooltipTipIcon />
                                        </Box>
                                        <Box display={'flex'} justifyContent={'flex-end'} className={classes.tooltipBtn}>
                                            <Button disableRipple onClick={handleClosePopover}>
                                                <TooltipClose />
                                            </Button>
                                        </Box>
                                        <Typography className={classes.typography}>{intl.formatMessage({id: "msg_info_upload_excel1"})}</Typography>
                                        <Typography className={classes.typography}>{intl.formatMessage({id: "msg_info_upload_excel2"})}</Typography>
                                    </Popover>
                                    <IconButton className={classes.iconButton} disableRipple onClick={handleClickUpload}>
                                        <UploadFile />
                                    </IconButton>
                                </>
                            }
                        </div>

                        <Button className={classes.buttonStyle} disableRipple onClick={handleClickAddUser}>
                            <AddaccountIcon/>
                            <Typography>{intl.formatMessage({id: "create_account"})}</Typography>
                        </Button>
                        <AddMember />
                        <MemberDetail />
                        <UploadDetail />
                    </Box>
                </Box>
                <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} className={classes.searchBox}>
                    <FormControl className={classes.formControl}>
                        <Select
                            value={userStore.tempSearchType}
                            onChange={handleChangeSearchType}
                            IconComponent={(props) => (
                                <Box>
                                    <ArrowDownIcon  {...props} />
                                </Box>
                            )}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "right"
                                },
                                transformOrigin:{
                                    vertical: 'top',
                                    horizontal: 'right',
                                },
                                getContentAnchorEl: null,
                                className:classes.selectPopover
                            }}
                        >
                            {searchTypeList.map((type, index) => (
                                <MenuItem key={index} value={type.value}>{type.label}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {(userStore.tempSearchType === 'state' || userStore.tempSearchType === 'localeCode' || userStore.tempSearchType === 'groupType') ?
                        <FormControl className={clsx(classes.formControl, classes.formControl2)}>
                            <Select
                                value={userStore.tempSearchText}
                                onChange={handleChangeSearchText}
                                IconComponent={(props) => (
                                    <Box>
                                        <ArrowDownIcon  {...props} />
                                    </Box>
                                )}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "right"
                                    },
                                    transformOrigin:{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    },
                                    getContentAnchorEl: null,
                                    className:classes.selectPopover
                                }}
                            >
                                {subSearchTypeList.map((type, index) => (
                                        <MenuItem key={index} value={type.value}>{type.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        :
                        <Box className={classes.textQuizBox} >
                            <TextField id="outlined-basic" variant="outlined" placeholder={getPlaceholder()} value={userStore.tempSearchText} onChange={handleChangeSearchText} disabled={userStore.tempSearchType === 'all'}/>
                        </Box>
                    }

                    <Button className={clsx(classes.buttonStyle, classes.buttonStyle3)} disableRipple onClick={handleClickSearch}>
                        <Typography>{intl.formatMessage({id: "search"})}</Typography>
                    </Button>
                </Box>


                <TabPanel value={value} index={tabList.findIndex(tab => tab.type === 'LocaleAdmin')} className={classes.textBox}>
                    <Box>
                        <TableContainer className={classes.tableBox}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead className={classes.tableHeadStyle}>
                                    <TableRow>
                                        <TableCell
                                            align='left'
                                            style={{minWidth: 55}}
                                        >
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>ID</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left" style={{minWidth: 55}}>
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "locale_in_charge"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left" style={{minWidth: 55}}>
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "email"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "affiliated_group_count"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left" onClick={handleClickCreatedDateSort} style={{minWidth: 120}}>
                                            <Box className={classes.sortButton}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "created_date"})}</Typography>
                                                {userStore.sortColumn === 'created_datetime' &&
                                                    (userStore.isSortAscending ? <TableSortIcon style={{transform: 'scaleY(-1)'}}/>: <TableSortIcon/>)
                                                }
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left" onClick={handleClickLastLoginDatetimeSort} style={{minWidth: 120}}>
                                            <Box className={classes.sortButton}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "recent_login"})}</Typography>
                                                {userStore.sortColumn === 'last_login_datetime' &&
                                                    (userStore.isSortAscending ? <TableSortIcon style={{transform: 'scaleY(-1)'}}/>: <TableSortIcon/>)
                                                }
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "state"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className={classes.tableBodyStyle}>
                                    {userStore.localeAdminUserList.map((user, index) => (
                                        <TableRow key={index}>
                                            <TableCell component="th" scope="row" align='left'>{user.id}</TableCell>
                                            <TableCell align="left">{intl.formatMessage({id: user.localeCode})}</TableCell>
                                            <TableCell align="left">{user.email}</TableCell>
                                            <TableCell align="left" style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={() => handleClickGroupCount(user.id)}>{user.groupCount}</TableCell>
                                            <TableCell align="left">{DATE_UTIL.getTimeZoneDate(user.createdDatetime, DATE_UTIL.FORMAT.DOT_DATE_FORMAT)}</TableCell>
                                            <TableCell align="left">{DATE_UTIL.getTimeZoneDate(user.lastLoginDatetime, DATE_UTIL.FORMAT.DOT_DATE_FORMAT)}</TableCell>
                                            <TableCell align="left">{intl.formatMessage({id: user.state})}</TableCell>
                                            <TableCell align="center">
                                                <Button className={classes.tableButton} disableRipple onClick={() => handelClickManage(user.id)}>{intl.formatMessage({id: "management"})}</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 15, 20]}
                            count={userStore.localeAdminUserCount}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage={intl.formatMessage({id: "rows_per_page"})}
                            page={userStore.page}
                            rowsPerPage={userStore.rowsPerPage}
                            component="div"
                            labelDisplayedRows={({ count, page }) => {
                                return <span className={classes.displayRow}><span>{page + 1}</span> / {Math.ceil(count / userStore.rowsPerPage)}</span>
                            }}
                            SelectProps={{
                                IconComponent: TextFieldDownIcon,
                                MenuProps: {
                                    className:classes.selectPopover
                                }
                            }}
                            className={classes.paginationBox}
                        />
                    </Box>
                </TabPanel>
                <TabPanel value={value} index={tabList.findIndex(tab => tab.type === 'GroupAdmin')} className={classes.textBox}>
                    <Box>
                        <TableContainer className={classes.tableBox}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead className={classes.tableHeadStyle}>
                                    <TableRow>
                                        <TableCell
                                            align='left'
                                            style={{minWidth: 55}}
                                        >
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>ID</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left" style={{minWidth: 55}}>
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "Locale"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left" style={{minWidth: 55}}>
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "group_type"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "group_name"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "email"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "account_count"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left" onClick={handleClickCreatedDateSort} style={{minWidth: 120}}>
                                            <Box className={classes.sortButton}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "created_date"})}</Typography>
                                                {userStore.sortColumn === 'created_datetime' &&
                                                    (userStore.isSortAscending ? <TableSortIcon style={{transform: 'scaleY(-1)'}}/>: <TableSortIcon/>)
                                                }
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left" onClick={handleClickLastLoginDatetimeSort} style={{minWidth: 120}}>
                                            <Box className={classes.sortButton}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "recent_login"})}</Typography>
                                                {userStore.sortColumn === 'last_login_datetime' &&
                                                    (userStore.isSortAscending ? <TableSortIcon style={{transform: 'scaleY(-1)'}}/>: <TableSortIcon/>)
                                                }
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "state"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className={classes.tableBodyStyle}>
                                    {userStore.groupAdminUserList.map((user, index) => (
                                        <TableRow key={index}>
                                            <TableCell component="th" scope="row" align='left'>{user.id}</TableCell>
                                            <TableCell align="left">{intl.formatMessage({id: user.localeCode})}</TableCell>
                                            <TableCell align="left">{intl.formatMessage({id: user.groupType})}</TableCell>
                                            <TableCell align="left">{user.groupName}</TableCell>
                                            <TableCell align="left">{user.email}</TableCell>
                                            <TableCell align="left" style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={() => handleClickUserCount(user.id)}>{user.userCount}</TableCell>
                                            <TableCell align="left">{DATE_UTIL.getTimeZoneDate(user.createdDatetime, DATE_UTIL.FORMAT.DOT_DATE_FORMAT)}</TableCell>
                                            <TableCell align="left">{DATE_UTIL.getTimeZoneDate(user.lastLoginDatetime, DATE_UTIL.FORMAT.DOT_DATE_FORMAT)}</TableCell>
                                            <TableCell align="left">{user.state}</TableCell>
                                            <TableCell align="center">
                                                <Button className={classes.tableButton} disableRipple onClick={() => handelClickManage(user.id)}>{intl.formatMessage({id: "management"})}</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 15, 20]}
                            count={userStore.groupAdminUserCount}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage={intl.formatMessage({id: "rows_per_page"})}
                            page={userStore.page}
                            rowsPerPage={userStore.rowsPerPage}
                            component="div"
                            labelDisplayedRows={({ count, page }) => {
                                return <span className={classes.displayRow}><span>{page + 1}</span> / {Math.ceil(count / userStore.rowsPerPage)}</span>
                            }}
                            SelectProps={{
                                IconComponent: TextFieldDownIcon,
                                MenuProps: {
                                    className:classes.selectPopover
                                }
                            }}
                            className={classes.paginationBox}
                        />
                    </Box>
                </TabPanel>
                <TabPanel value={value} index={tabList.findIndex(tab => tab.type === 'Normal')} className={classes.textBox}>
                    <input id={'memberUpload'} style={{ display: 'none' }} accept={".xlsx, .xls"} onChange={uploadFile} placeholder={intl.formatMessage({id: "full_file"})} type={'file'}/>
                    <Box>
                        <TableContainer className={classes.tableBox}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead className={classes.tableHeadStyle}>
                                    <TableRow>
                                        <TableCell
                                            align='left'
                                            style={{minWidth: 55}}
                                        >
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>ID({intl.formatMessage({id: "email"})})</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left" style={{minWidth: 55}}>
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "name"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left" style={{minWidth: 55}}>
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "nickname"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "Locale"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "group_name"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left" onClick={handleClickCreatedDateSort} style={{minWidth: 120}}>
                                            <Box className={classes.sortButton}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "created_date"})}</Typography>
                                                {userStore.sortColumn === 'created_datetime' &&
                                                    (userStore.isSortAscending ? <TableSortIcon style={{transform: 'scaleY(-1)'}}/>: <TableSortIcon/>)
                                                }
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left" onClick={handleClickLastLoginDatetimeSort} style={{minWidth: 120}}>
                                            <Box className={classes.sortButton}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "recent_login"})}</Typography>
                                                {userStore.sortColumn === 'last_login_datetime' &&
                                                    (userStore.isSortAscending ? <TableSortIcon style={{transform: 'scaleY(-1)'}}/>: <TableSortIcon/>)
                                                }
                                            </Box>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                                <AlignLeftIcon/><Typography>{intl.formatMessage({id: "state"})}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className={classes.tableBodyStyle}>
                                    {userStore.normalUserList.map((user, index) => (
                                        <TableRow key={index}>
                                            <TableCell component="th" scope="row" align='left'>{user.id}</TableCell>
                                            <TableCell align="left">{user.name}</TableCell>
                                            <TableCell align="left">{user.nickName}</TableCell>
                                            <TableCell align="left">{user.localeCode !== null ? intl.formatMessage({id: user.localeCode}) : ''}</TableCell>
                                            <TableCell align="left">{user.groupName}</TableCell>
                                            <TableCell align="left">{DATE_UTIL.getTimeZoneDate(user.createdDatetime, DATE_UTIL.FORMAT.DOT_DATE_FORMAT)}</TableCell>
                                            <TableCell align="left">{DATE_UTIL.getTimeZoneDate(user.lastLoginDatetime, DATE_UTIL.FORMAT.DOT_DATE_FORMAT)}</TableCell>
                                            <TableCell align="left">{user.state}</TableCell>
                                            <TableCell align="center">
                                                <Button className={classes.tableButton} disableRipple onClick={() => handelClickManage(user.id)}>{intl.formatMessage({id: "management"})}</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 15, 20]}
                            count={userStore.normalUserCount}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage={intl.formatMessage({id: "rows_per_page"})}
                            page={userStore.page}
                            rowsPerPage={userStore.rowsPerPage}
                            component="div"
                            labelDisplayedRows={({ count, page }) => {
                                return <span className={classes.displayRow}><span>{page + 1}</span> / {Math.ceil(count / userStore.rowsPerPage)}</span>
                            }}
                            SelectProps={{
                                IconComponent: TextFieldDownIcon,
                                MenuProps: {
                                    className:classes.selectPopover
                                }
                            }}
                            className={classes.paginationBox}
                        />
                    </Box>
                </TabPanel>
            </Box>
        </Box>
    );
}

export default inject('userStore', 'authStore')(injectIntl(observer(MemberTable)));
